import type { Coordinate } from 'ol/coordinate';

import { ajax } from 'cadenza/api-client/api';

export async function find3Words(coordinates: Coordinate, srsCode: string): Promise<string> {
  const params = new URLSearchParams();
  params.set(
    'point',
    JSON.stringify({
      type: 'Point',
      coordinates,
    }),
  );
  params.set('srsCode', srsCode);
  return await ajax<string>(`/reverse-geocoding-what3words?${params.toString()}`);
}
